import ITitles from '../../shared/interfaces/titles.interface';

export const TITLE_REPORTS: ITitles = {
    icon: 'report',
    title: 'Reportes',
    description: 'Elige el mes y el año que desees para revisar el informe de facturación de las clases que has dado en tu sede.',
}